import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  & .MuiOutlinedInput-root {
    padding: 8px;
    border-radius: ${({ theme }) => theme.borderRadius};
    font-family: ${({ theme }) => theme.font.family};
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${({ theme }) => theme.mainTheme.color.blue50};
      border-width: 1px !important;

      :focus {
        border: 1px solid ${({ theme }) => theme.mainTheme.color.blue50};
      }
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${({ theme }) => theme.mainTheme.color.blue50};
      border-width: 1px;
    }


    &.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: #d32f2f;
    }
  }

  & .MuiFormHelperText-root {
    margin: 3px 14px 0px;
  }
`;
